import React, { useEffect, useState, useRef } from 'react';
import DashboardLayout from '../layouts/DashboardLayout';
import TaskBoard from '../components/TaskBoard';
import { gsap } from 'gsap';

const MyTask = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const popupRef = useRef(null);
  const timelineRef = useRef(null);

  useEffect(() => {
    if (sessionStorage.getItem('justLoggedIn')) {
      setShowLoader(true);
      sessionStorage.removeItem('justLoggedIn');
      setTimeout(() => {
        setShowLoader(false);
        setShowSuccess(true);
      }, 2000);
    }
  }, []);

  useEffect(() => {
    if (showSuccess && popupRef.current) {
      gsap.set(popupRef.current, { y: 32, opacity: 0, scale: 0.95, background: '#27ae60' });
      if (timelineRef.current) timelineRef.current.kill();
      const tl = gsap.timeline({
        onComplete: () => setShowSuccess(false)
      });
      tl.to(popupRef.current, {
        y: 0,
        opacity: 1,
        scale: 1.08,
        duration: 0.5,
        ease: 'back.out(1.7)'
      })
      .to(popupRef.current, {
        scale: 1,
        duration: 0.18,
        ease: 'power1.out'
      })
      .to(popupRef.current, {
        background: '#2ecc71',
        duration: 0.18,
        yoyo: true,
        repeat: 1,
        ease: 'power1.inOut'
      }, '-=0.1')
      .to(popupRef.current, {
        delay: 0.7,
        opacity: 0,
        y: 32,
        scale: 0.95,
        duration: 0.5,
        ease: 'power2.in'
      });
      timelineRef.current = tl;
    }
  }, [showSuccess]);

  return (
    <DashboardLayout>
      {showLoader && (
        <div className="v-loader-overlay">
          <svg className="v-loader-svg v-loader-animate" width="120" height="120" viewBox="0 0 120 120">
            <defs>
              <linearGradient id="v-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#e30613" stopOpacity="1" />
                <stop offset="50%" stopColor="#ff4757" stopOpacity="1" />
                <stop offset="100%" stopColor="#e30613" stopOpacity="1" />
              </linearGradient>
              <filter id="v-glow" x="-30%" y="-30%" width="160%" height="160%">
                <feDropShadow dx="0" dy="0" stdDeviation="4" floodColor="#e30613" floodOpacity="0.3" />
                <feDropShadow dx="0" dy="0" stdDeviation="8" floodColor="#e30613" floodOpacity="0.15" />
              </filter>
            </defs>
            <g className="v-loader-glow">
              <path
                className="v-loader-path"
                d="M 35 40 L 60 80 L 85 40"
                fill="none"
                strokeWidth="12"
                strokeLinecap="round"
                filter="url(#v-glow)"
              />
            </g>
            {/* Background circle for depth */}
            <circle
              cx="60"
              cy="60"
              r="45"
              fill="none"
              stroke="rgba(227, 6, 19, 0.1)"
              strokeWidth="2"
              strokeDasharray="5,5"
              opacity="0.6"
            />
          </svg>
        </div>
      )}
      {showSuccess && (
        <div ref={popupRef} className="login-success-popup show">
          <span className="login-success-icon">✔</span>
          Login successfully
        </div>
      )}
      <div className="mytask-wrapper">
        <TaskBoard />
      </div>
    </DashboardLayout>
  );
};

export default MyTask;


/*
.login-success-popup {
  position: fixed;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%) translateY(40px);
  background: #27ae60;
  color: white;
  padding: 1rem 2.5rem;
  border-radius: 2rem;
  font-weight: 600;
  font-size: 1.1rem;
  box-shadow: 0 8px 32px rgba(39, 174, 96, 0.18), 0 1.5px 8px rgba(0,0,0,0.08);
  z-index: 2000;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  opacity: 0;
  pointer-events: none;
  animation: login-success-in 0.6s cubic-bezier(.4,2,.6,1) forwards;
}
.login-success-popup.show {
  opacity: 1;
  pointer-events: auto;
  animation: login-success-in 0.6s cubic-bezier(.4,2,.6,1) forwards;
}
.login-success-popup:not(.show) {
  animation: login-success-out 0.4s cubic-bezier(.4,2,.6,1) forwards;
}
.login-success-icon {
  font-size: 1.5rem;
  background: #fff;
  color: #27ae60;
  border-radius: 50%;
  width: 2.2rem;
  height: 2.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(39, 174, 96, 0.12);
}
@keyframes login-success-in {
  from { opacity: 0; transform: translateX(-50%) translateY(40px) scale(0.95); }
  to { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
}
@keyframes login-success-out {
  from { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
  to { opacity: 0; transform: translateX(-50%) translateY(40px) scale(0.95); }
}
*/ 